module.exports = {"platforms":[{"message":"Start Platform","type":"FiniteImmobilePlatform","x":256,"y":416,"width":160,"height":192,"display":{"assetName":"temple"}},{"message":"Goal Platform","type":"FiniteImmobilePlatform","x":480,"y":128,"width":160,"height":480,"display":{"assetName":"temple"}},{"message":"blocker","type":"FiniteImmobilePlatform","x":256,"y":128,"width":160,"height":32,"display":{"assetName":"lanterns"}}],"goal":{"x":576,"y":128},"player":{"x":288,"y":350},"par":1}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/friend-1-vert.json
// module id = 135
// module chunks = 0